import { useState } from "react";
import ICONS from "../../../../assets/Icons/index.js";
import accountNameStandardised from "../../../../utils/accountNamestandardised.js";
import { GlobalConfiguration } from "../../../../utils/configurationProvider.js";
import { linkIdentifier } from "../../../../utils/linkIdentifier.js";
import TextInputField from "../../CommonInputFields/TextInputField";
import SingleSelectAndInput from "./SingleSelectAndInput.jsx";

const ContactDetails = ({
  handleChange,
  emailValidation,
  contactNumberValidation,
  contactNumber,
  accountName,
  emailId,
  selectedValue,
  previewMode = false,
}) => {
  const [focusState, setFocusState] = useState({});
  const [touched, setTouched] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({
    label: "+91",
    icon: "https://q2pay.in/new_assets/common/countries/india.svg",
  });
  if (previewMode) {
    return (
      <div className="global-card-create">
        <p className="text-text-primary font-semibold text-base mb-margin-md">
          Contact Details
        </p>

        <div className="flex flex-col gap-gap-md">
          <div className="flex flex-row items-center gap-gap-sm">
            <div className="flex">
              <img
                className="w-icon-sm h-icon-sm flex-shrink-0"
                src={ICONS?.PROFILE_UNSELECTED}
                alt="User"
              />
            </div>

            <div>
              <p className="text-base text-text-primary">
                {accountNameStandardised(accountName)}
              </p>
              <p className="text-xs text-text-secondary">Account name</p>
            </div>
          </div>
          <div className="flex flex-row items-center gap-gap-sm">
            <div className="flex">
              <img
                className="w-icon-sm h-icon-sm flex-shrink-0"
                src={ICONS?.CONTACT_WITH_WHITE_CIRCLE}
                alt="Contact"
              />
            </div>
            <div>
              <p className="text-base text-text-primary">
                +91- {contactNumber}
              </p>
              <p className="text-xs text-text-secondary">Contact number</p>
            </div>
          </div>
          <div className="flex flex-row items-center gap-gap-sm">
            <div className="flex">
              <img
                className="w-icon-sm h-icon-sm flex-shrink-0"
                src={ICONS?.CONTACT_US_MAIL}
                alt="Gmail"
              />
            </div>
            <div>
              <p className="text-base text-text-primary">
                {linkIdentifier(emailId.toLowerCase())}
              </p>
              <p className="text-xs text-text-secondary">Email ID</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col relative w-width-full z-z-index-content">
      <div className="p-padding-md bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="text-text-primary font-semibold text-base">
            Contact Details
          </div>
          <div className="flex flex-col gap-gap-sm">
            <div className="">
              <SingleSelectAndInput
                showSearch
                searchPlaceholder="Search country by code or name"
                selected={selectedCountry}
                setSelected={setSelectedCountry}
                placeholder="Country"
                options={[
                  {
                    longLabel: "+91 (India)",
                    label: "+91",
                    icon: "https://q2pay.in/new_assets/common/countries/india.svg",
                  },
                ]}
                inputProps={{
                  variant:
                    contactNumber?.length === GlobalConfiguration.panLength &&
                    contactNumberValidation
                      ? "verified"
                      : focusState?.contact_no
                        ? "typing"
                        : !touched?.contact_no
                          ? "default"
                          : contactNumber?.length ===
                              GlobalConfiguration.lengthCheckZero
                            ? "default"
                            : contactNumber?.length <
                                GlobalConfiguration.panLength
                              ? "error"
                              : "error",

                  placeholder: "Contact number",
                  bgColor: "var(--primary-card)",
                  fgColor: "var(--text-secondary)",
                  value: contactNumber,
                  name: "contact_no",
                  adornment: ICONS?.CONTACT_WITH_WHITE_CIRCLE,
                  onInput: (e) => {
                    if (
                      !(
                        e.target.name === "account_name" &&
                        selectedValue === "legalname"
                      )
                    ) {
                      handleChange(e);
                    }
                  },
                  isFullWidth: true,
                  onFocus: () =>
                    setFocusState((s) => ({ ...s, contact_no: true })),

                  onBlur: () => {
                    setFocusState((s) => ({ ...s, contact_no: false }));
                    setTouched((t) => ({ ...t, contact_no: true }));
                  },
                }}
              />
            </div>
            <div>
              <TextInputField
                variant={
                  emailId?.length > GlobalConfiguration.lengthCheckZero &&
                  emailValidation
                    ? "verified"
                    : focusState?.email_id
                      ? "typing"
                      : emailId?.length > GlobalConfiguration.lengthCheckZero
                        ? "error"
                        : "default"
                }
                placeholder="Email ID"
                bgColor="var(--primary-card)"
                fgColor="var(--text-primary)"
                value={emailId?.replace(/\s/g, "")}
                name="email_id"
                adornment={ICONS?.CONTACT_US_MAIL}
                onInput={(e) => {
                  if (
                    !(
                      e.target.name === "account_name" &&
                      selectedValue === "legalname"
                    )
                  ) {
                    handleChange(e);
                  }
                }}
                isFullWidth={true}
                onFocus={() => setFocusState((s) => ({ ...s, email_id: true }))}
                onBlur={() => {
                  setFocusState((s) => ({ ...s, email_id: false }));
                  setTouched((t) => ({ ...t, email_id: true }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
